/* eslint-disable */

import React, { Component } from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';

import { Button } from 'semantic-ui-react';
import {
  IMessage,
  FBMessenger,
  FBMessengerUrl,
  InstagramUrlDM,
  Whatsapp
} from '../share';

import icons from '../../assets/images/facebook-icons-dates.png';
import iconsV2 from '../../assets/images/facebook-icons-v2.png';
import iconsV3 from '../../assets/images/facebook-icons-v3.png';
import reactions from '../../assets/images/facebook-icons-reactions.png';

const Container = styled.div`
  margin-bottom: 20px;
  overflow: hidden;
  max-width: 100%;
`;
const Original = styled.div`
  float: left;
`;
const Media = styled.div``;
const MediaContent = styled.div`
  float: left;
  width: 375px;
  position: relative;
  border-radius: 4px;
  background-color: #fff;
  margin-bottom: 10px;
  border: 1px solid #dddfe2;
`;
const Image = styled.img`
  max-width: 373px;
`;
const TopContainer = styled.div`
  margin-bottom: -6px;
  zoom: 1;
`;
const ProfileContainer = styled.div`
  padding: 7px;
  margin-bottom: -1px;
  zoom: 1;
`;
const LinkProfile = styled.a`
  padding-bottom: 3px;
  float: left;
  margin-right: 8px;
`;
const ImageProfileRelative = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
`;
const ImageProfileContainer = styled.div`
  ::after {
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.1);
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;
const ImageProfile = styled.img`
  border-radius: 50%;
  overflow: hidden;
  height: 40px;
  width: 40px;
`;
const TextProfileContainer = styled.div`
  overflow: hidden;
`;
const TextProfile = styled.div`
  padding-bottom: 6px;
`;
const ProfileTitleContainer = styled.h5`
  margin-bottom: 2px;
  padding-right: 22px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.38;
  text-align: left;
  font-weight: bold;
`;
const LinkProfileText = styled.a`
  color: #365899;
  cursor: pointer;
  text-decoration: none;
`;
const SubtitleContainer = styled.div`
  color: #616770;
  font-size: 12px;
  text-align: left;
`;
const SettingsContainer = styled.div`
  position: absolute;
  opacity: 1;
  right: 0;
  top: 0;
  z-index: 3;
`;
const SettingsLink = styled.div`
  margin-right: 7px;
  background-image: ${() => `url(${iconsV2})`};
  background-repeat: no-repeat;
  background-size: auto;
  background-position: -21px -230px;
  height: 20px;
  margin-top: 8px;
  width: 20px;
`;
const DateLink = styled.a`
  color: #616770;
`;
const LockImage = styled.i`
  bottom: -1px;
  margin-bottom: -5px;
  position: relative;
  vertical-align: top;
  width: 12px;
  height: 12px;
  background-position: 0 -118px;
  background-image: ${() => `url(${icons})`};
  background-size: auto;
  background-repeat: no-repeat;
  display: inline-block;
`;
const MessageContainer = styled.div`
  margin: 6px 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.38;
  padding: 0 10px;
`;
const Message = styled.p`
  margin: 0 0 6px 0;
  text-align: left;
`;
const ReactionsContainer = styled.div`
  color: #90949c;
  padding-bottom: 4px;
  position: relative;
  margin-top: -5px;
`;
const ReactionsContent = styled.div`
  padding-bottom: 4px;
  padding-top: 4px;
  margin: 0 12px;
  margin-bottom: -4px;
  display: flex;
`;
const ReactionsLeft = styled.div`
  flex-grow: 1;
  order: 1;
`;
const ReactionsLeftContent = styled.div`
  display: flex;
  flex-direction: row;
`;
const ReactionsRight = styled.div`
  display: flex;
  height: 32px;
  float: none;
  order: 2;
  padding-left: 3px;
  align-items: center;
`;
const ProfileBotom = styled.div`
  max-width: 200px;
  align-items: center;
  border: none;
  display: flex;
  height: 32px;
  line-height: 22px;
`;
const ProfileArrow = styled.i`
  width: 9px;
  height: 8px;
  background-position: -18px -537px;
  background-image: ${() => `url(${iconsV3})`};
  background-size: auto;
  background-repeat: no-repeat;
  display: inline-block;
`;
const ProfileImageBottom = styled.img`
  bottom: 1px;
  position: relative;
  vertical-align: middle;
  margin-right: 4px;
`;
const Reaction = styled.span`
  display: flex;
  height: 32px;
  flex: 1 100%;
`;
const ReactionContent = styled.div`
  display: flex;
  height: 32px;
  justify-content: center;
  margin: 0;
  padding: 0;
  white-space: nowrap;
  width: 100%;
  position: relative;
`;
const ReactionLink = styled.a`
  align-items: center;
  justify-content: center;
  display: flex;
  color: #616770;
  font-size: 13px;
  padding: 0 2px;
  text-decoration: none;
  font-weight: 600;
  line-height: 14px;
  white-space: nowrap;
  width: 100%;
  transition: 400ms cubic-bezier(0.08, 0.52, 0.52, 1) filter,
    400ms cubic-bezier(0.08, 0.52, 0.52, 1) transform;
  :hover {
    background-color: #f2f2f2 !important;
    color: #616770;
  }
  ::before {
    background-position: ${(props) => `${props.bgPosition}`};
    background-image: ${() => `url(${reactions})`};
    background-size: auto;
    background-repeat: no-repeat;
    height: 18px;
    min-width: 18px;
    position: relative;
    top: -4px;
    width: 18px;
    position: relative;
    content: '';
    display: inline-block;
    margin: 0 6px -3px 0;
  }
  ::after {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -5px;
    top: -5px;
    content: '';
    display: block;
  }
`;
const Previews = styled.div`
  float: left;
  width: 62.5%;
  margin-left: 25px;
  max-width: 900px;
`;
const ButtonContainer = styled.div`
  width: 100%;
  margin-top: 15px;
`;

class MediaFacebookComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false
    };
  }

  toggleShow = () => {
    // localStorage.setItem('Shared', !this.state.show);
    this.setState({ show: !this.state.show });
    return false;
  };

  subStr = (text, limit) => {
    const maxLenght = !limit ? 100 : limit;
    return text.length > maxLenght
      ? `${text.substring(0, maxLenght)}...`
      : text;
  };

  render() {
    const { item } = this.props;
    const media = item;
    const showMedia = media.length > 0;

    const settings = {
      infinite: false,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    return (
      <Container>
        <Original>
          <Media className="preview-container preview-media-facebook">
            <MediaContent>
              <ProfileContainer>
                <SettingsContainer>
                  <SettingsLink />
                </SettingsContainer>
                <TopContainer>
                  <LinkProfile href="">
                    <ImageProfileRelative>
                      <ImageProfileContainer>
                        <ImageProfile src={media.user.profile_picture} />
                      </ImageProfileContainer>
                    </ImageProfileRelative>
                  </LinkProfile>
                  <TextProfileContainer>
                    <TextProfile>
                      <div>
                        <ProfileTitleContainer>
                          <span>
                            <LinkProfileText>
                              {media.user.full_name}
                            </LinkProfileText>
                          </span>
                        </ProfileTitleContainer>
                        <SubtitleContainer>
                          <span>
                            <DateLink href="">
                              <abbr />
                              <span>16 de mayo</span>
                            </DateLink>
                          </span>
                          <span> · </span>
                          <span>
                            <LockImage />
                          </span>
                        </SubtitleContainer>
                      </div>
                    </TextProfile>
                  </TextProfileContainer>
                </TopContainer>
              </ProfileContainer>
              <MessageContainer>
                <div>
                  <Message>{media.caption.text}</Message>
                </div>
              </MessageContainer>
              <Image
                src={media.images.standard_resolution.url}
                alt={media.link}
              />
              <ReactionsContainer>
                <ReactionsContent>
                  <ReactionsRight>
                    <ProfileBotom>
                      <span>
                        <a href="javascript:void(0)">
                          <ProfileImageBottom
                            src={media.user.profile_picture}
                            width="16"
                          />
                        </a>
                      </span>
                      <span>
                        <ProfileArrow />
                      </span>
                    </ProfileBotom>
                  </ReactionsRight>
                  <ReactionsLeft>
                    <ReactionsLeftContent>
                      <Reaction>
                        <ReactionContent>
                          <ReactionLink
                            href="javascript:void(0)"
                            bgPosition="0 -171px"
                          >
                            Like
                          </ReactionLink>
                        </ReactionContent>
                      </Reaction>
                      <Reaction>
                        <ReactionContent>
                          <ReactionLink
                            href="javascript:void(0)"
                            bgPosition="0 -114px"
                          >
                            Comment
                          </ReactionLink>
                        </ReactionContent>
                      </Reaction>
                      <Reaction>
                        <ReactionContent>
                          <ReactionLink
                            href="javascript:void(0)"
                            bgPosition="0 -304px"
                          >
                            Share
                          </ReactionLink>
                        </ReactionContent>
                      </Reaction>
                    </ReactionsLeftContent>
                  </ReactionsLeft>
                </ReactionsContent>
              </ReactionsContainer>
            </MediaContent>
            <ButtonContainer>
              <Button onClick={() => this.toggleShow()} fluid secondary>
                Test Share
              </Button>
            </ButtonContainer>
          </Media>
        </Original>
        {this.state.show && (
          <Previews className="previews-slider">
            <Slider {...settings}>
              <IMessage
                image={media.images.standard_resolution.url}
                source={`facebook.com`}
                description={media.user.full_name}
                link={media.link}
                subStr={this.subStr}
                facebook
              />
              <FBMessenger
                title=""
                description={media.caption.text}
                image={media.images.standard_resolution.url}
                source={media.user.full_name}
                link={media.link}
                subStr={this.subStr}
                facebook
              />
              <FBMessengerUrl
                title=""
                description={media.caption.text}
                image={media.images.standard_resolution.url}
                source={media.user.full_name}
                link={media.link}
                subStr={this.subStr}
                facebook
              />
              {/* <InstagramDM
                image={media.images.standard_resolution.url}
                author={media.user.full_name}
                authorImage=""
                description={media.caption.text}
                link={media.link}
                subStr={this.subStr}
                facebook
              /> */}
              <InstagramUrlDM
                image={media.images.standard_resolution.url}
                author=""
                authorImage=""
                description={media.caption.text}
                link={media.link}
                subStr={this.subStr}
                facebook
              />
              <Whatsapp
                image={media.images.standard_resolution.url}
                shortDescription={media.caption.text}
                description={media.user.full_name}
                metadata={``}
                link={media.link}
                source={`www.facebook.com`}
                subStr={this.subStr}
                facebook
              />
            </Slider>
          </Previews>
        )}
      </Container>
    );
  }
}

export default MediaFacebookComponent;



// WEBPACK FOOTER //
// ./src/components/share/MediaFacebook.js